import {Controller} from '@hotwired/stimulus';
import type {Application} from '@hotwired/stimulus';

export class PaginationController extends Controller<HTMLElement> {
    static values = {
        jump: String
    };

    static register(application: Application) {
        application.register('pagination', this);
    }

    jump(event) {
        const target = document.querySelector(this.jumpValue);
        if (!target) return;

        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        });
    }
}